import { defineTokens } from '@chakra-ui/react';

import { aiGradient, partialPrimaryGradient, softOrangeFade } from '../primitives/colors';

export const GRADIENTS = defineTokens({
  gradients: {
    primary: { value: partialPrimaryGradient },
    ai: { value: aiGradient },
    softOrangeFade: { value: softOrangeFade },
  },
});
